import React from 'react';
import PropTypes from 'prop-types';
import CheckboxSwitch from '../../common/checkboxSwitch';
import AdvanceBookingForm from '../../common/advanceBookingForm';
import { RoleAllowAdmin, RoleAwareShop } from '../../auth/roleAware';
import FeesForm from './feesForm';
import RemindTime from '../../common/remindTime';
import BookingSettings from './bookingSettings';

const BarberSettings = ({ currency, canCustomerCancel, paymentDepositsEnabled }) => (
  <div>
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">Options</div>
    <div className="c-wrapper-horizontal u-pb--">
      <div className="layout">
        {!paymentDepositsEnabled && <BookingSettings />}
        <CheckboxSwitch
          name="allowMultipleServices"
          id="allowMultipleServices"
          label="Allow multiple services"
          wrapperClass="layout__item"
        />
        <RoleAwareShop>
          <div className="layout__item">
            <RemindTime />
          </div>
        </RoleAwareShop>
        <AdvanceBookingForm canCustomerCancel={canCustomerCancel} />
      </div>
    </div>
    <div className="c-separator u-mv" />
    <RoleAllowAdmin>
      <div className="c-separator u-mb u-mt" />
      <FeesForm currency={currency} />
    </RoleAllowAdmin>
  </div>
);

BarberSettings.propTypes = {
  currency: PropTypes.string.isRequired,
  canCustomerCancel: PropTypes.bool.isRequired,
  paymentDepositsEnabled: PropTypes.bool.isRequired,
};

export default BarberSettings;
